import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  addElement as addElementToLayoutGroup
} from '../redux/layoutGroups'

export default function * requestAddLinkToLayoutGroup (action) {
  const { layoutId, layoutGroupId, name, url, position } = action.payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = yield optimisticPut(addElementToLayoutGroup({
    key: `${layoutId}-${layoutGroupId}`,
    elementId: tempId,
    type: 'link',
    name,
    url,
    position,
    isBusy: true
  }))

  try {
    yield call(apiAction, 'AddLinkToLayoutGroup', {
      layoutId,
      groupId: layoutGroupId,
      name,
      url,
      position
    })
  } finally {
    yield optimisticAction.revert()
  }
}
